export default "__VITE_ASSET__DEoY$YGg__"